<template>
    <v-container>
      <v-card>
        <v-toolbar dense color="secondary" flat>
          <v-toolbar-title>
            <span style="color: red">{{ selectedCustomer.Name }}</span> - Customer
            Statement
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" small text to="/debtors">
            <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
          </v-btn>
        </v-toolbar>
  
        <v-card-text>
          <div>
            <v-row>
              <v-col cols="12" xs="12" md="3">
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      dense
                      outlined
                      single-line
                      v-model="record.StartDate"
                      label="From"
                      prepend-icon="mdi-calendar-month"
                      v-on="on"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="record.StartDate"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
  
              <!-- datepicker 2 -->
              <v-col cols="12" xs="12" md="3">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      dense
                      outlined
                      single-line
                      v-model="record.EndDate"
                      label="To"
                      prepend-icon="mdi-calendar-month"
                      v-on="on"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="record.EndDate"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
  
              <v-col cols="2">
                <v-btn color="accent" :loading="loader" @click="getReport"
                  >Query Data</v-btn
                >
              </v-col>
            </v-row>
  
            <v-row class="subtitle-2 text--primary">
              <v-col cols="12" xs="12" md="9" class="mb-2">
                <v-btn color="primary" text small @click="printStatement">
                  <v-icon left color="black">mdi-printer</v-icon>
                  Statement Pdf</v-btn
                >
  
                <!-- <v-btn text @click="printStatementViaThermal" color="accent">
                  <v-icon color="black" left>mdi-printer</v-icon> Print Statement
                  Via Thermal
                </v-btn> -->
                <br />
  
                <div>
                  Balance as Of {{ record.StartDate }}:
                  <span style="color: red">{{
                    auditData.openingBalance &&
                    auditData.openingBalance.toLocaleString()
                  }}</span>
                </div>
              </v-col>
  
              <v-col cols="12" xs="12" md="9">
                <v-text-field
                  v-model="search"
                  dense
                  label="Search"
                ></v-text-field>
                <!-- table headers -->
                <v-data-table
                  dense
                  :headers="headers"
                  :items="jdt1"
                  :search="search"
                >
                  <template v-slot:item.DocEntry="{ item }">
                    <v-btn
                      v-if="item.ObjType == 14"
                      text
                      color="primary"
                      @click="openSummaryModal(item.DocEntry)"
                    >
                      {{ item.DocEntry }}
                      <v-icon right>mdi-eye</v-icon>
                    </v-btn>
  
                    <v-btn
                      v-if="item.ObjType == 15"
                      text
                      color="green"
                      @click="getRct1Record(item)"
                    >
                      {{ item.DocEntry }}
                      <v-icon right>mdi-eye</v-icon>
                    </v-btn>
  
                    <v-btn
                      v-if="item.ObjType == 23"
                      text
                      color="red"
                      @click="getReturnRecords(item.DocEntry)"
                    >
                      {{ item.DocEntry }}
                      <v-icon right>mdi-eye</v-icon>
                    </v-btn>
                  </template>
  
                  <template v-slot:item.Remarks="{ item }">
                    <v-btn
                      v-if="item.ObjType == 14"
                      text
                      color="primary"
                      @click="openSummaryModal(item.DocEntry)"
                      >{{ item.Remarks }}</v-btn
                    >
            
                    <v-btn
                      v-if="item.ObjType == 23"
                      text
                      color="red"
                      @click="getReturnRecords(item.DocEntry)"
                      >{{ item.Remarks }}</v-btn
                    >
                    <v-btn
                      v-if="item.ObjType == 15"
                      text
                      color="green"
                      @click="getRct1Record(item)"
                      >{{ item.Remarks }}</v-btn
                    >
                  </template>
  
                  <template v-slot:item.Amount="{ item }">
                    <span v-if="item.ObjType == 15"> - {{
                      item.Amount.toLocaleString()
                    }}</span>
                    <span v-else>{{ item.Amount.toLocaleString() }}</span>
                  </template>
  
                  <template v-slot:item.Balance="{ item }">
                    <span>{{ item.Balance.toLocaleString() }}</span>
                  </template>
                </v-data-table>
                <!-- end -->
              </v-col>
  
              <v-col cols="12" xs="12" md="6" class="mb-2">
                <div>
                  Balance as Of {{ record.EndDate }}:
                  <span style="color: red">{{
                    auditData.closingBalance &&
                    auditData.closingBalance.toLocaleString()
                  }}</span>
                  <!-- <span
                    style="color: red"
                    v-else
                  >{{auditData.ClosingBalance.toLocaleString()}}</span>-->
                </div>
              </v-col>
  
              <!-- <v-col cols="12" xs="12" md="3" class="mb-2">
                <div>
                  <span v-if="auditData.totalDebit">Total Debit: {{auditData.totalDebit.toLocaleString()}}</span>
                </div>
                <div>
                  <span v-if="auditData.totalCredit">Total Credit: {{auditData.totalCredit.toLocaleString()}}</span>
                </div>
              </v-col>-->
            </v-row>
  
            <!-- details modal -->
            <v-dialog
              v-model="summaryDialog"
              fullscreen
              hide-overlay
              transition="dialog-bottom-transition"
            >
              <v-card style="background-color: #eceff1">
                <v-toolbar dark color="accent" dense>
                  <v-toolbar-title>
                    <v-btn icon dark @click.native="summaryDialog = false">
                      <v-icon dark>mdi-keyboard-backspace</v-icon> </v-btn
                    >Invoice History Details
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon dark @click.native="summaryDialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
  
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" xs="12" md="10">
                        <!-- purchases -->
                        <v-card>
                          <v-toolbar color="secondary" dense flat>
                            <v-toolbar-title>Sale Invoice</v-toolbar-title>
                          </v-toolbar>
  
                          <v-card-text>
                            <v-row dense class="subtitle-2 text--primary">
                              <v-col cols="12" xs="12" sm="12" md="3">
                                <span v-if="oignRecord.ocrd">
                                  Supplier: {{ oignRecord.ocrd.Name }}
                                  <br />
                                  Order number: {{ oignRecord.DocNum }}<br />
                                  Date: {{ oignRecord.DocDate }}
                                  <br />
                                </span>
                              </v-col>
  
                              <v-col cols="12" xs="12" sm="12" md="3">
                                <span v-if="oignRecord.ocrd">
                                  Total:
                                  {{ oignRecord.DocTotal.toLocaleString() }}
                                  <br />
                                  <!-- Amount Paid:
                                  {{ oignRecord.PaidSum.toLocaleString() }} <br />
                                  Balance:
                                  {{ oignRecord.Balance.toLocaleString() }} -->
                                </span>
                              </v-col>
  
                              <v-col cols="12" xs="12" sm="12" md="3">
                                <span v-if="oignRecord.ocrd">
                                  <span v-if="oignRecord.store"
                                    >Store: {{ oignRecord.store.Name }}</span
                                  >
                                </span>
                              </v-col>
  
                              <v-col cols="12">
                                <v-text-field
                                  v-model="search"
                                  label="Search"
                                  outlined
                                  dense
                                ></v-text-field>
                                <v-data-table
                                  light
                                  :search="search"
                                  :items-per-page="100"
                                  :headers="oignHeaders"
                                  :items="oignRecord.rows"
                                  item-key="o_i_t_m_s_id"
                                  disable-sort
                                  :mobile-breakpoint="0"
                                >
                                  <template v-slot:item.Name="{ item }">
                                    <span v-if="item.product">{{
                                      item.product.Name
                                    }}</span>
                                  </template>
                                  <template v-slot:item.Price="{ item }">
                                    <span v-if="item.Price">{{
                                      item.Price.toLocaleString()
                                    }}</span>
                                  </template>
                                  <template v-slot:item.LineTotal="{ item }">
                                    <span v-if="item.LineTotal">{{
                                      item.LineTotal.toLocaleString()
                                    }}</span>
                                  </template>
                                </v-data-table>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                        <!-- end -->
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
            <!-- end of details modal -->
  
            <!-- payments modal -->
            <v-dialog
              v-model="orctDialog"
              fullscreen
              hide-overlay
              transition="dialog-bottom-transition"
            >
              <v-card style="background-color: #eceff1">
                <v-toolbar dark color="accent" dense>
                  <v-toolbar-title>
                    <v-btn icon dark @click.native="orctDialog = false">
                      <v-icon dark>mdi-keyboard-backspace</v-icon> </v-btn
                    >Payment Details
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon dark @click.native="orctDialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
  
                <v-card-text>
                  <v-container>
                    <v-row justify="center" class="subtitle-2 text--primary">
                      <v-col cols="12" xs="12" md="10" v-if="orctRecord">
                        Date: {{ orctRecord.DocDate }}<br />
                        Amount Paid: {{ orctRecord.CashSum }}
                      </v-col>
  
                      <v-col
                        cols="12"
                        xs="12"
                        md="10"
                        v-if="orctRecord.rows && orctRecord.rows.length > 0"
                      >
                        <v-data-table
                          light
                          :items-per-page="100"
                          :headers="kct2Headers"
                          :items="orctRecord.rows"
                          item-key="id"
                          disable-sort
                          :mobile-breakpoint="0"
                        >
                          <template v-slot:item.SumApplied="{ item }">
                            <span>{{
                              item.SumApplied && item.SumApplied.toLocaleString()
                            }}</span>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
            <!-- end of payments dialog -->
  
            <!-- start of sales returns dialog -->
            <v-dialog
              v-model="returnDialog"
              fullscreen
              hide-overlay
              transition="dialog-bottom-transition"
            >
              <v-card style="background-color: #eceff1">
                <v-toolbar dark color="accent" dense>
                  <v-toolbar-title>
                    <v-btn icon dark @click.native="returnDialog = false">
                      <v-icon dark>mdi-keyboard-backspace</v-icon> </v-btn
                    >Sale Return
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon dark @click.native="returnDialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
  
                <v-card-text>
                  <v-container>
                    <v-row
                      dense
                      justify="center"
                      class="subtitle-2 text--primary"
                      v-if="docReturns"
                    >
                      <v-col cols="12" xs="12" sm="12" md="10" style="color: red">
                        <v-card>
                          <v-toolbar color="secondary" dense flat>
                            <v-toolbar-title>Return Details</v-toolbar-title>
                          </v-toolbar>
  
                          <v-card-text>
                            <v-row class="subtitle-2 text--primary">
                              <v-col cols="12" md="12">
                                <span>
                                  Doc Total:
                                  {{
                                    docReturns.DocTotal &&
                                    docReturns.DocTotal.toLocaleString()
                                  }}
                                  <br />
                                  Return Date: {{ docReturns.DocDate }}
                                  <br />
                                </span>
                              </v-col>
  
                              <v-col cols="12" md="12">
                                <v-data-table
                                  light
                                  :items-per-page="100"
                                  :headers="returnHeaders"
                                  :items="docReturns.rows"
                                  item-key="id"
                                  disable-sort
                                  :mobile-breakpoint="0"
                                >
                                  <template v-slot:item.product="{ item }">
                                    <span
                                      v-if="item.product"
                                      style="color: red"
                                      >{{ item.product.Name }}</span
                                    >
                                  </template>
                                  <template v-slot:item.Quantity="{ item }">
                                    <span
                                      style="color: red"
                                      v-if="item.Quantity"
                                      >{{ item.Quantity.toLocaleString() }}</span
                                    >
                                  </template>
                                  <template v-slot:item.Price="{ item }">
                                    <span style="color: red" v-if="item.Price">{{
                                      item.Price.toLocaleString()
                                    }}</span>
                                  </template>
                                  <template v-slot:item.LineTotal="{ item }">
                                    <span
                                      style="color: red"
                                      v-if="item.LineTotal"
                                      >{{ item.LineTotal.toLocaleString() }}</span
                                    >
                                  </template>
                                </v-data-table>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
            <!-- end of returns dialog -->
  
            <!-- start of debt payment dialog -->
            <v-dialog
              v-model="paymentDialog"
              fullscreen
              hide-overlay
              transition="dialog-bottom-transition"
            >
              <v-card style="background-color: #eceff1">
                <v-toolbar dark color="accent" dense>
                  <v-toolbar-title>
                    <v-btn icon dark @click.native="paymentDialog = false">
                      <v-icon dark>mdi-keyboard-backspace</v-icon> </v-btn
                    >Payment Details
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon dark @click.native="paymentDialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
  
                <v-card-text>
                  <v-container>
                    <v-row
                      dense
                      justify="center"
                      class="subtitle-2 text--primary"
                    >
                      <v-col cols="12" xs="12" sm="12" md="10" style="color: red">
                        <v-card>
                          <v-toolbar color="secondary" dense flat>
                            <v-toolbar-title>Payment Details</v-toolbar-title>
                          </v-toolbar>
  
                          <v-card-text>
                            <v-row class="subtitle-2 text--primary">
                              <v-col cols="12" md="12"> </v-col>
  
                              <v-col cols="12" md="12">
                                <v-data-table
                                  light
                                  :items-per-page="100"
                                  :headers="rct1Headers"
                                  :items="rct1Record"
                                  item-key="id"
                                  disable-sort
                                  :mobile-breakpoint="0"
                                >
                                  <template v-slot:item.SumApplied="{ item }">
                                    <span
                                      style="color: red"
                                      v-if="item.SumApplied"
                                      >{{
                                        item.SumApplied.toLocaleString()
                                      }}</span
                                    >
                                  </template>
                                </v-data-table>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
            <!-- end of payment dialog -->
  
            <!-- start of payment dialog -->
            <v-dialog
              v-model="jdt1Dialog"
              fullscreen
              hide-overlay
              transition="dialog-bottom-transition"
            >
              <v-card style="background-color: #eceff1">
                <v-toolbar dark color="accent" dense>
                  <v-toolbar-title>
                    <v-btn icon dark @click.native="jdt1Dialog = false">
                      <v-icon dark>mdi-keyboard-backspace</v-icon> </v-btn
                    >Payment Details
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon dark @click.native="jdt1Dialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
  
                <v-card-text>
                  <v-container>
                    <v-row
                      dense
                      justify="center"
                      class="subtitle-2 text--primary"
                    >
                      <v-col cols="12" xs="12" sm="12" md="10" style="color: red">
                        <v-card>
                          <v-toolbar color="secondary" dense flat>
                            <v-toolbar-title>Payment Details</v-toolbar-title>
                          </v-toolbar>
  
                          <v-card-text>
                            <v-row class="subtitle-2 text--primary">
                              <v-col cols="12" md="12"> </v-col>
  
                              <v-col cols="12" md="12">
                                <v-data-table
                                  light
                                  :items-per-page="100"
                                  :headers="jdt1Headers"
                                  :items="jdt1Records"
                                  item-key="id"
                                  disable-sort
                                  :mobile-breakpoint="0"
                                >
                                  <template v-slot:item.Debit="{ item }">
                                    <span style="color: red" v-if="item.Debit">{{
                                      item.Debit.toLocaleString()
                                    }}</span>
                                  </template>
                                </v-data-table>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
            <!-- end of payment dialog -->
  
            <snackbar ref="snackbar"></snackbar>
          </div>
        </v-card-text>
      </v-card>
      <!-- snackbar -->
      <snackbar ref="snackbar"></snackbar>
    </v-container>
  </template>
  
  <script>
  import { http } from "@/common/index";
  import jsPDF from "jspdf";
  import "jspdf-autotable";
  export default {
    data() {
      return {
        oignRecord: {},
        orctDialog: false,
        paymentDialog: false,
        docReturns: {},
        record: {},
        orctRecord: {},
        summaryDialog: false,
        productsDialog: false,
        returnDialog: false,
        jdt1Dialog: false,
        jdt1Records: [],
        selectedCustomer: {},
        saleRecord: {},
        rct1Record: [],
        soldItems: [],
        menu1: false,
        menu2: false,
        search: null,
        loader: false,
        brands: [],
        customers: [],
        stockReport: [],
        categories: [],
        invoicesData: [],
        invoiceLoader: false,
        auditData: {},
        jdt1: [],
        kct2: [],
        headers: [
          { text: "Date", value: "DocDate" },
          { text: "Transaction", value: "Remarks" },
          { text: "DocEntry", value: "DocEntry" },
          { text: "Amount", value: "Amount" },
          { text: "Balance", value: "Balance" },
        ],
        oignHeaders: [
          { text: "Product", value: "Name" },
          { text: "Qty", value: "Quantity" },
          // { text: "Purchase UOM", value: "UomEntry" },
          { text: "Price", value: "Price" },
          // { text: "Tax", value: "TaxId" },
          { text: "Total", value: "LineTotal" },
          // { text: "Action", value: "action" },
        ],
        returnHeaders: [
          { text: "Product", value: "product" },
          { text: "Qty", value: "Quantity" },
          { text: "Price", value: "Price" },
          { text: "Total", value: "LineTotal" },
        ],
        kct2Headers: [
          { text: "Account", value: "oact.Name" },
          { text: "Amount", value: "SumApplied" },
          { text: "Date", value: "created_at" },
        ],
        rct1Headers: [
          { text: "Date", value: "DocDate" },
          { text: "Account", value: "oact.Name" },
          { text: "Amount", value: "SumApplied" },
          { text: "Ref / Transaction Code", value: "PaymentRemarks" }
        ],
        jdt1Headers: [
          { text: "Account", value: "oact.Name" },
          { text: "Amount", value: "Debit" },
          { text: "Date", value: "DocDate" },
        ],
        soldHeaders: [
          { text: "Product", value: "Name" },
          { text: "Qty", value: "Quantity" },
          { text: "Price", value: "Price" },
          { text: "Total", value: "DisplayTotal" },
        ],
      };
    },
    computed: {
      storeName() {
        return localStorage.getItem("storeName");
      },
    },
    watch: {
      "$route.params.id": {
        handler: "singleCustomer",
        immediate: true,
      },
    },
    methods: {
      moreDetails(data) {
        if (data.ObjType == 14) {
          this.getSaleProducts(data.DocEntry);
        }
      },
      openSummaryModal(DocEntry) {
        const self = this;
        this.$store.commit("loader", true);
        this.$store
          .dispatch("get", `/statement/details/14/${DocEntry}`)
          .then((res) => {
            if (res.ResultCode == 1200) {
              self.oignRecord = res.ResponseData.origDoc;
              self.kct2 = res.ResponseData.payments;
              self.docReturns = res.ResponseData.returns;
              self.$store.commit("loader", false);
              self.summaryDialog = true;
            } else {
              self.$store.commit("loader", false);
              this.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch((err) => {
            self.$store.commit("loader", false);
            this.$refs.snackbar.show(err, "red");
          });
      },
      getSaleProducts(val) {
        const self = this;
        this.$store.commit("loader", true);
        self.saleRecord = {};
        this.$store
          .dispatch("get", `/documents/14/${val}`)
          .then((res) => {
            if (res.ResultCode == 1200) {
              self.saleRecord = res.ResponseData;
              const products = [];
              if (res.ResponseData.rows) {
                for (const row of res.ResponseData.rows) {
                  row.Name = row.product.Name;
                  row.DisplayTotal = row.LineTotal.toLocaleString();
                  products.push(row);
                }
                self.soldItems = products;
                self.productsDialog = true;
                this.$store.commit("loader", false);
              }
            } else {
              this.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch((err) => {
            this.$refs.snackbar.show(err, "red");
          });
      },
      printStatementViaThermal() {
        const data = this.auditData;
        return http.post("http://localhost:3000/print/customer/statement", {
          auditData: data,
        });
      },
      getReport() {
        const data = this.record;
        data.CardCode = this.selectedCustomer.id;
        const url = `/business-partner-audit-statement/18`;
        const self = this;
        this.$store.commit("loader", true);
        this.$store
          .dispatch("post", { url, data })
          .then((res) => {
            if (res.ResultCode == 1200) {
              self.auditData = res.ResponseData;
              self.jdt1 = res.ResponseData.bpAudit;
              self.$store.commit("loader", false);
            } else {
              this.$refs.snackbar.show(res.msg, "red");
              self.$store.commit("loader", false);
            }
          })
          .catch((err) => {
            self.$store.commit("loader", false);
            this.$refs.snackbar.show(err, "red");
          });
      },
      getDebtPaymentRecords(DocEntry) {
        const self = this;
        this.$store.commit("loader", true);
        this.$store
          .dispatch("get", `/audit-debt-payments/${DocEntry}`)
          .then((res) => {
            if (res.ResultCode == 1200) {
              self.orctRecord = res.ResponseData;
              self.orctDialog = true;
              self.$store.commit("loader", false);
            } else {
              this.$refs.snackbar.show(res.msg, "red");
            }
          })
          .catch((err) => {
            this.$refs.snackbar.show(err, "red");
          });
      },
      getReturnRecords(DocEntry) {
        const self = this;
        this.$store.commit("loader", true);
        this.$store
          .dispatch("get", `/credit-memo-details/${DocEntry}`)
          .then((res) => {
            if (res.ResultCode == 1200) {
              self.docReturns = res.ResponseData;
              self.returnDialog = true;
              self.$store.commit("loader", false);
            } else {
              this.$refs.snackbar.show(res.msg, "red");
            }
          })
          .catch((err) => {
            this.$refs.snackbar.show(err, "red");
          });
      },
      getJdt1Record(id) {
        const self = this;
        this.$store.commit("loader", true);
        this.$store
          .dispatch("get", `/get-jdt1-record/${id}`)
          .then((res) => {
            if (res.ResultCode == 1200) {
              self.jdt1Records = res.ResponseData;
              self.jdt1Dialog = true;
              self.$store.commit("loader", false);
            } else {
              this.$refs.snackbar.show(res.msg, "red");
            }
          })
          .catch((err) => {
            this.$refs.snackbar.show(err, "red");
          });
      },
      getRct1Record(item) {
        let data = {};
        data.CardCode = item.CardCode;
        data.DocEntry = item.id;
        const url = "/get-rct1-record";
        const self = this;
        self.$store.commit("loader", true);
        this.$store
          .dispatch("post", { url, data })
          .then((res) => {
            if (res.ResultCode == 1200) {
              self.rct1Record = res.ResponseData;
              self.paymentDialog = true;
              self.$store.commit("loader", false);
            } else {
              this.$refs.snackbar.show(res.msg, "red");
              self.$store.commit("loader", false);
            }
          })
          .catch((err) => {
            this.$refs.snackbar.show(err, "red");
          });
      },
      singleCustomer(val) {
        const self = this;
        this.$store.commit("loader", true);
        this.$store
          .dispatch("get", `/customers/${val}`)
          .then((res) => {
            if (res.ResultCode == 1200) {
              self.selectedCustomer = res.ResponseData;
              self.$store.commit("loader", false);
            } else {
              this.$refs.snackbar.show(res.msg, "red");
            }
          })
          .catch((err) => {
            this.$refs.snackbar.show(err, "red");
          });
      },
      invSummary() {
        const data = this.record;
        data.CustomerId = this.selectedCustomer.id;
        const url = "/invoices-summary/14";
        const self = this;
        this.invoiceLoader = true;
        this.$store
          .dispatch("post", { url, data })
          .then((res) => {
            if (res.ResultCode == 1200) {
              self.invoicesData = res.ResponseData.AllSales;
              self.invoiceLoader = false;
              self.printInvoiceSummary();
            } else {
              this.$refs.snackbar.show(res.msg, "red");
            }
          })
          .catch((err) => {
            this.$refs.snackbar.show(err, "red");
          });
      },
      printStatement() {
        const shopName = this.storeName;
        var doc = new jsPDF({ compress: true });
        var totalPagesExp = "{total_pages_count_string}";
        // var pageHeight =
        //   doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
        var pageWidth =
          doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
  
        var img = new Image();
        img.src = require("@/assets/stock.png");
        doc.addImage(img, "png", 10, 5, 100, 40);
  
        doc.setFontSize(15);
        doc.setTextColor(0, 0, 0);
        doc.setFont("Georgia, serif");
        doc.text(shopName, pageWidth - 53, 15, "center");
        const customerName = this.selectedCustomer.Name;
        //Setting Items Title:
        doc.setFontSize(15);
        doc.text("Customer Statement", pageWidth / 2, 57, "center");
        doc.text(customerName, pageWidth / 2, 65, "center");
  
        doc.setFontSize(13);
        doc.text(
          "From: " + this.record.StartDate + "   " + "To: " + this.record.EndDate,
          pageWidth / 2,
          72,
          "center"
        );
        doc.setFontSize(12);
  
        // Variables to Hold Data
        let dataSummaryRows = [];
  
        function dataSummaryColumns() {
          return [
            {
              count: "",
              name: "Amount",
            },
          ];
        }
  
        const availableQty = {
          count: "Opening Balance",
          name: this.auditData.openingBalance.toLocaleString(),
        };
  
        dataSummaryRows.push(availableQty);
  
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(11);
        doc.setFont("Georgia, serif");
        doc.autoTable({
          head: dataSummaryColumns(),
          body: dataSummaryRows,
          theme: "grid",
          tableWidth: 80,
          columnStyles: {
            count: {
              fontStyle: "bold",
            },
          },
          startY: 74,
          styles: { overflow: "hidden", cellPadding: 1, font: "Georgia, serif" },
          margin: { right: 100 },
        });
  
        let startingPoint = doc.autoTable.previous.finalY + 8;
        // start of the loop
          // end
          var columns = [
            { title: "Date", dataKey: "DocDate" },
            { title: "Title", dataKey: "Remarks" },
            { title: "Amount", dataKey: "Amount" },
            { title: "New Balance", dataKey: "Balance" }
          ];
  
          let dataRows = [];
  
          const allSales = this.jdt1;
        dataRows = allSales.map((alldata) => {
          return {
            DocDate: alldata.DocDate,
            Remarks: alldata.Remarks,
            Amount: alldata.Amount.toLocaleString(),
            Balance: alldata.Balance.toLocaleString(),
          };
        });
  
          doc.autoTable(columns, dataRows, {
            theme: "grid",
            startY: startingPoint,
            didDrawPage: function (data) {
              // Header
              doc.setFontSize(20);
              doc.setTextColor(40);
  
              // Footer
              var str = "Page " + doc.internal.getNumberOfPages();
              // Total page number plugin only available in jspdf v1.0+
              if (typeof doc.putTotalPages === "function") {
                str = str + " of " + totalPagesExp;
              }
              doc.setFontSize(10);
  
              // jsPDF 1.4+ uses getWidth, <1.4 uses .width
              var pageSize = doc.internal.pageSize;
              var pageHeight = pageSize.height
                ? pageSize.height
                : pageSize.getHeight();
              doc.text(str, data.settings.margin.left, pageHeight - 10);
              //Setting Foouter
              doc.setTextColor(22, 160, 133);
              doc.setFontSize(10);
              var today = new Date();
              doc.text("" + today, pageWidth / 2, pageHeight - 5, "center");
            },
          });
  
          startingPoint = doc.autoTable.previous.finalY + 8;
  
        // end of the loop
  
        let closingSummaryRows = [];
        function closingSummaryColumns() {
          return [
            {
              count: "",
              name: "Amount",
            },
          ];
        }
  
        const closingData = {
          count: "Outstanding Balance",
          name: this.auditData.closingBalance.toLocaleString(),
        };
  
        closingSummaryRows.push(closingData);
  
        doc.autoTable({
          head: closingSummaryColumns(),
          body: closingSummaryRows,
          theme: "grid",
          tableWidth: 80,
          columnStyles: {
            count: {
              fontStyle: "bold",
            },
          },
          startY: doc.autoTable.previous.finalY + 8,
          headStyles: { fillColor: [255, 87, 51] },
          styles: { overflow: "hidden", cellPadding: 1, font: "Georgia, serif" },
          margin: { right: 100 },
        });
  
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === "function") {
          doc.putTotalPages(totalPagesExp);
        }
        doc.save("Customer-statement.pdf");
        // doc.output("dataurlnewwindow");
      },
    },
    created() {},
  };
  </script>
  
  <style lang="scss" scoped>
  </style>